import { AnimatePresence, motion } from 'framer-motion';
import Styles from './menuCategoryNav.module.scss';

export const MenuCategoryNav = ({ label }) => {
	return (
		<aside className={Styles.nav}>
			<AnimatePresence>
				<motion.div
					key={label}
					className={Styles.label}
					initial={{ opacity: 0, y: 56 }}
					animate={{ opacity: 1, y: 0 }}
					exit={{ opacity: 0, y: -56 }}
					transition={{ duration: 0.5, ease: 'easeInOut' }}
				>
					{label.split('').map((char, index) => (
						<span key={`${char}-${index}`}>{char}</span>
					))}
				</motion.div>
			</AnimatePresence>
		</aside>
	);
};
